import React from 'react';
import OptionalDecorationBoundary from './OptionalDecorationBoundary';

interface LayoutFeatureProps {
  /** The page feature this content belongs to (a `PageFeatures` key). */
  name: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Wraps a test layout's page content (docs/test-layouts.md, "Page features"). It marks the content with
 * `data-layout-feature`, which the checks use to prove none reaches a public layout, and a failure inside
 * renders nothing instead of taking the page down with it.
 */
export default function LayoutFeature({ name, className, children }: LayoutFeatureProps) {
  return (
    <OptionalDecorationBoundary decoration="layout_feature" feature={name}>
      <div data-layout-feature={name} className={className}>{children}</div>
    </OptionalDecorationBoundary>
  );
}
